import { Box, Typography } from '@mui/material'
import React from 'react'

const IndexComponent = ({ label, value }) => {
    return (
        <Box>
            <Typography variant="h6" sx={{ textTransform: "capitalize" }}>
                {label}

            </Typography>
            <Typography

                sx={{
                    backgroundColor: "#F7FAFF",
                    border: "1px solid #4169E1",
                    borderRadius: "5px",
                    padding: "10px 10px",
                    fontSize: "12px",
                }}
            >
                {value}
            </Typography>
        </Box>
    )
}

export default IndexComponent







